export const isEmployee = (worker: TWorker): worker is Employee =>
  worker.workerType === 'employee'

export const isContingentWorker = (
  worker: TWorker,
): worker is ContingentWorker => worker.workerType === 'contingent_worker'
